var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { ResponsiveChoropleth, ResponsiveGeoMap } from '@nivo/geo';
import countries from "./geo/countries.json";

import "./ChartLine.scss";

var ChartChoropleth = (_temp2 = _class = function (_Component) {
    _inherits(ChartChoropleth, _Component);

    function ChartChoropleth() {
        var _temp, _this, _ret;

        _classCallCheck(this, ChartChoropleth);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getDomain = function () {
            var _this$props = _this.props,
                domain = _this$props.domain,
                minimum = _this$props.minimum,
                maximum = _this$props.maximum;


            if (minimum && maximum) {
                domain = [0, maximum];
            }

            return domain;
        }, _this.getProps = function () {

            return _extends({}, _this.props, {
                domain: _this.getDomain()
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    ChartChoropleth.prototype.render = function render() {
        var props = this.getProps();

        return React.createElement(ResponsiveChoropleth, props);
    };

    return ChartChoropleth;
}(Component), _class.defaultProps = {
    data: [],

    features: countries.features,
    colors: undefined,

    projectionScale: 100,

    projectionTranslation: [0.5, 0.5],

    projectionRotation: [0, 0, 0],

    enableGraticule: false,
    graticuleLineColor: "#dddddd",

    label: "properties.name",

    unknownColor: "#eeeeee",

    borderWidth: 0.25,
    borderColor: "#ffffff",

    domain: [0, 1000000],
    margin: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }

}, _temp2);


export default ChartChoropleth;